import React from 'react'
import KanBoIcon from 'components/KanBoIcon'
import classes from '../Navbar.module.scss'

export class NavbarBreadcrumb extends React.Component {
  render () {
    const {
      children,

      ...restProps
    } = this.props

    let childCount = 0

    return (
      <div
        {...restProps}
        className={classes.navbarBreadcrumb}
      >
        {React.Children.map(children, child => {
          if (!React.isValidElement(child)) return null

          childCount++

          return (
            <React.Fragment>
              {(childCount >= 2) &&
                <div className={classes.navbarBreadcrumbDivider}>
                  <KanBoIcon name='kanbo-16-chevron-right' />
                </div>
              }
              {child}
            </React.Fragment>
          )
        })}
      </div>
    )
  }
}

export default NavbarBreadcrumb
